<template>
  <div>
    <b-container class="container--max-750 text-center mt-6">
      <h1 class="h3 mb-4">{{ $t("lang.label_certificate_step3") }}</h1>
    </b-container>
    <b-container class="container--max-810 mt-6">
      <b-card>
        <h4 class="mb-4 asterisk">{{ $t("lang.label_certificate_certificateRequest") }}</h4>
        <b-tabs v-model="tabIndex" nav-class="mb-4">
          <b-tab :title="$t('lang.label_certificate_enterAsText')" active>
            <div id="application-package-content-text">
              <b-form @submit.prevent="onCsrTextSubmit" novalidate :validated="wasCsrValidated">
                <b-form-group>
                  <b-form-textarea
                    v-model="base64Text"
                    :required="tabIndex === 0"
                    :placeholder="$t('lang.label_placeholder_enterText')"
                    rows="5"
                    class="form-control"
                    id="application-package-text"
                    ref="application-package-text"
                  ></b-form-textarea>
                  <b-form-invalid-feedback>{{ $t("lang.message_certificate_create_invalidBase64_text") }}</b-form-invalid-feedback>
                </b-form-group>
                <div class="text-right">
                  <b-button type="submit" variant="primary">
                    {{ $t("lang.button_readData") }}
                  </b-button>
                </div>
              </b-form>
            </div>
          </b-tab>
          <b-tab :title="$t('lang.label_certificate_uploadFile')">
            <div id="application-package-content-file">
              <b-form novalidate>
                <b-form-group>
                  <b-form-file
                    v-model="base64FileObject"
                    :state="wasCsrValidated ? Boolean(base64FileObject) : null"
                    :placeholder="$t('lang.label_chooseFile')"
                    drop-placeholder="Drop file here..."
                    @input="onCsrFileSubmit()"
                  ></b-form-file>
                </b-form-group>
              </b-form>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
    <b-container class="container--max-810 mt-5">
      <b-card>
        <b-form @submit.prevent="onSubmit" novalidate :validated="wasValidated">
          <form-group-certificate v-model="certificate"></form-group-certificate>

          <div class="text-right mt-2">
            <b-button type="submit" size="lg" variant="primary"> {{ $t("lang.label_certificate_apply") }}</b-button>
          </div>
        </b-form>
        <div>{{ $t("lang.label_star_explained") }}</div>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import FormGroupCertificate from "../../components/certificate/FormGroupCertificate";
import CertificateCryptoType from "../../api/enums/CertificateCryptoType";
import CertificateKeyPairMode from "../../api/enums/CertificateKeyPairMode";
import CertificateValidity from "../../api/enums/CertificateValidity";

export default {
  name: "CreateCertificateWizardStep3FromCsr",
  data() {
    return {
      /* CSR input */
      tabIndex: 0,
      base64Text: "",
      base64FileObject: null,

      /* Certificate */
      certificate: {
        country: "",
        commonName: "",
        org: "",
        orgUnit: "",
        email: "",
        domainName: "",
        validFor: CertificateValidity.THREE_MONTHS,
        certUsageType: null,
        certPublicKeyAlgorithm: null,
        certSignatureAlgorithm: null,
        pkcs10ReqBase64: null,
        certCryptoType: CertificateCryptoType.TRADITIONAL,
        keyPairMode: CertificateKeyPairMode.PKCS10
      },
      wasCsrValidated: false,
      wasValidated: false
    };
  },
  methods: {
    onCsrTextSubmit: function(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasCsrValidated = true;
        return;
      }
      this.pkcs10ReqBase64 = this.base64Text;
      this.getCertificateRequestFromBase64();
    },
    onCsrFileSubmit: function() {
      if (!this.base64FileObject) {
        this.wasCsrValidated = true;
        return;
      }
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
          this.pkcs10ReqBase64 = reader.result;
          this.getCertificateRequestFromBase64();
        };
        reader.onerror = reject;
        reader.readAsText(this.base64FileObject);
      });
    },
    onSubmit(evt) {
      if (evt.target.checkValidity() === false) {
        this.wasValidated = true;
        return;
      }
      this.createCertificate();
    },
    createCertificate() {
      this.$store
        .dispatch("certificate/createCertificate", this.certificate)
        .then(response => {
          this.$router.push({
            name: "certificate-detail",
            params: {
              id: response.data.certificate.id
            }
          });
        })
        .catch(() => {
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_create_error"), { root: true });
        });
    },
    getCertificateRequestFromBase64() {
      this.$store
        .dispatch("certificate/parseCsrBase64", this.pkcs10ReqBase64)
        .then(response => {
          this.certificate = Object.assign({}, this.certificate, response.data);
          this.certificate.validFor = CertificateValidity.THREE_MONTHS; // fix Resetting  validfor-object copy overrides the default values so validfor becomes null
        })
        .catch(error => {
          if (error.response) {
            if (this.tabIndex === 1) {
              this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_create_invalidBase64_file"));
            } else {
              this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_create_invalidBase64_text"));
            }
          }
        });
    }
  },
  components: { FormGroupCertificate }
};
</script>
